import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./user";
import interfaceReducer from "./interface";
import { cartReducer } from "./cartSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    interface: interfaceReducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
export type AppDispatch = typeof store.dispatch;
